// Ô SỐ của trang Kịch bản (05/10/2026, người dùng: "đừng đặt số nhóm hay bình luận… TỐI ĐA — chỉ đưa ra lời khuyên chứ không ép"): khoảng
// min/max của thao tác là KHUYẾN NGHỊ → nhãn "(khuyên 1–3)" và một dòng lời khuyên mềm dưới ô khi giá trị vượt khuyến nghị (không chặn lưu).
// Giá trị vô nghĩa / quá trần kỹ thuật vẫn bị chặn ở bộ kiểm (máy chủ + kiemThamSoThem). Luật ở src/shared/khuyen-nghi-so.ts (dùng chung máy chủ).
// Tệp riêng để kich-ban.ts chỉ gắn 2 lời gọi (thẻ bước + bảng thêm bước).
import { canhBaoKhuyenNghi, nhanKhoang, type ThamSoSo } from "../../../../src/shared/khuyen-nghi-so";
import { h } from "../dom";

/** Nhãn khoảng sau tên ô: " (khuyên 1–3)" / " (0–30)"; null khi ô không phải số hoặc không có khoảng. */
export function nhanKhoangSo(p: ThamSoSo): HTMLElement | null {
  const s = nhanKhoang(p);
  return s ? h("span", { class: "muted", "data-testid": "kb-khoang" }, s) : null;
}

/** Dòng lời khuyên mềm dưới ô số — cập nhật theo từng phím gõ; ẩn khi giá trị nằm trong khuyến nghị / không phải số. null khi ô không phải số. */
export function canhBaoSo(inp: HTMLInputElement, p: ThamSoSo, testId: string, mang?: string): HTMLElement | null {
  if (p.kieu !== "so") return null;
  const el = h("span", { class: "kb-o-khuyen", role: "status", "data-testid": testId });
  const cap = (): void => {
    const c = canhBaoKhuyenNghi(p, inp.value, mang);
    el.textContent = c ? `⚠ ${c}` : "";
    el.hidden = !c;
  };
  inp.addEventListener("input", cap);
  cap();
  return el;
}
